import { AlertProps } from '@chakra-ui/react';

export const emptyAlertStyle: AlertProps = {
    variant: 'subtle',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '200px',
    width: '500px',
    borderRadius: '8px',
    boxShadow: 'base',
};
